import PriceManagemant from './price-managemant';

export default PriceManagemant;
